/** Namespace `overview` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const overview = {
  title: "Tổng quan",
  subtitle: "Trạng thái và xu hướng của toàn hệ sinh thái.",
  healthFailed: "Không đọc được sức khoẻ của hub.",
  audienceFailed: "Không đọc được số người dùng.",
  p1Banner: "{count} sự cố mức P1 chưa được giải quyết. Mục đã ghi nhận vẫn tính — ghi nhận không phải là hết vấn đề.",

  "health.title": "Sức khoẻ của hub",
  "health.status": "Trạng thái",
  "health.ok": "Bình thường",
  "health.degraded": "Suy giảm",
  "health.database": "Cơ sở dữ liệu",
  "health.dbOk": "Kết nối được",
  "health.dbDown": "Không kết nối được",
  "health.latency": "Độ trễ",

  "business.title": "Kinh doanh",
  "business.audienceLink": "Xem chi tiết người dùng",
  "business.sumNote": "Ba thẻ dưới là phép CỘNG mọi app (một người ở hai app bị đếm hai lần) — số của từng app ở ngay dưới.",
  "business.newUsers30d": "Người dùng mới (30 ngày)",

  "pending.title": "Ba nhóm còn lại chưa đo được.",
  "pending.bodyBefore":
    "Gói đăng ký, doanh thu, dung lượng và phản hồi khách hàng cần thêm nguồn và thêm lát cắt. Chúng sẽ hiện ở đây kèm nhãn chất lượng — « Ước tính », « Cũ », « Không hỗ trợ » — chứ không bao giờ hiện",
  "pending.bodyAfter": "khi thật ra là chưa đo được.",
} as const;
